import { handleCatchNotValidationError } from 'utils/handleCatchNotValidationError';
import { queryUrls } from 'shared/constants/queryApiUrl-constants';
import { TOPICS_CONSTANTS } from 'shared/constants/topics.constants';
import { setTopicSuggestions, setTopicError } from 'redux/slices/app/app.slice';
import { splitApi } from './split.api';

export interface TopicSuggestion {
  thesis: string;
  description: string;
}

export interface GenerateTopicsParams {
  url?: string;
  text?: string;
}

export const TopicsApi = splitApi.injectEndpoints({
  endpoints: (build) => ({
    generateTopics: build.mutation<TopicSuggestion[], GenerateTopicsParams>({
      query: (params: GenerateTopicsParams) => ({
        url: queryUrls.topicsApi.generateTopics,
        method: 'POST',
        body: params,
      }),
      async onQueryStarted(_: GenerateTopicsParams, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(setTopicSuggestions(data));
        } catch (err) {
          handleCatchNotValidationError(err, dispatch);
          dispatch(setTopicError(TOPICS_CONSTANTS.ERROR_MESSAGE));
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGenerateTopicsMutation } = TopicsApi;
